import React from 'react'
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import Transition from 'shared/Transition'

interface VinAssignmentModalProps {
  open: boolean
  onClose: () => void
  handleYesClick: any
  headerText: string
}

export const VinAssignmentModal: React.FC<VinAssignmentModalProps> = ({
  open,
  onClose,
  headerText,
  handleYesClick,
}) => {

  return null

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      sx={{ minWidth: '20vw', padding: '15px 20px 20px 0', }}
    >
      <DialogTitle id="dialog-title">
        {headerText === 'Assign'
          ? 'Are you sure you want to assign a VIN to an active subscription?'
          : 'Are you sure you want to unassign a VIN from an active subscription?'}
      </DialogTitle>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          onClick={handleYesClick}
          autoFocus
          variant="contained"
          color="primary"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}
